<template>
  <div class="tw:flex tw:min-h-screen tw:items-center tw:justify-center tw:bg-gray-50 tw:p-4 tw:sm:p-6">
    <div class="tw:w-full tw:max-w-[560px] tw:rounded-[12px] tw:bg-white tw:p-6 tw:shadow-xs tw:sm:p-10">
      <slot />
    </div>
  </div>
</template>
